import { useSelector } from 'react-redux';

import { ReviewsItem } from '../../components/ReviewsItem';
import { getReviewById } from '../../selectors/reviews';
import { AnswerListContainer } from '../AnswerList';
import { AuthorContainer } from './Author';
import { AvatarContainer } from './Avatar';
import { CommentContainer } from './Comment';
import { FooterContainer } from './Footer';

interface IReviewsItemContainerProps {
  id: string;
  inPopup?: boolean;
}

export function ReviewsItemContainer({ id, inPopup }: IReviewsItemContainerProps) {
  const review = useSelector(getReviewById(id));
  const { isLegacy, labels } = review;

  return (
    <>
      <ReviewsItem
        id={id}
        aside={<AvatarContainer reviewId={id} />}
        author={<AuthorContainer {...review} />}
        label={isLegacy ? labels[0] : null}
        comment={<CommentContainer reviewId={id} />}
        footer={<FooterContainer reviewId={id} inPopup={inPopup} />}
      />
      <AnswerListContainer reviewId={id} />
    </>
  );
}
